import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { useLanguage } from '../../context/LanguageContext';

export default function AppsSection() {
  const { t, isRTL } = useLanguage();

  const features = [
    t('comingSoon.ourApp.features.book')        || 'Book your doctor anytime',
    t('comingSoon.ourApp.features.consult')     || 'Online medical consultations',
    t('comingSoon.ourApp.features.reminders')   || 'Medication reminders',
    t('comingSoon.ourApp.features.records')     || 'Your medical records always with you',
  ];

  return (
    <section
      dir={isRTL ? 'rtl' : 'ltr'}
      className="relative mt-12 sm:mt-16 lg:mt-56 h-screen"
    >
      <div className="relative">
        {/* Title */}
        <h2 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-secondary  ${isRTL ? 'lg:pe-[30%] text-left' : 'lg:pe-[27%] text-right'} px-4 sm:px-6 lg:px-0 mb-8 lg:mb-0`}>
          Dr<span className="text-primary">EASY</span>
        </h2>

        <div className="py-12 sm:py-16 bg-gradient-to-r from-secondary to-primary flex flex-col items-center justify-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">

              {/* Image */}
              <div className="flex justify-center lg:justify-start order-1 lg:order-1">
                <div className="relative w-full max-w-sm sm:max-w-md lg:max-w-lg">
                  <img
                    src="/images/AppsImg.png"
                    alt={t('comingSoon.ourApp.imageAlt') || 'Dr Easy Mobile App'}
                    className="w-full h-auto drop-shadow-2xl lg:absolute lg:-top-[350px] lg:left-0 xl:-left-4 lg:scale-[120%] xl:scale-[140%] xl:w-[900px] relative lg:z-40"
                  />
                </div>
              </div>

              {/* Content */}
              <div className={`text-white space-y-4 sm:space-y-6 order-2 lg:order-2 px-4 sm:px-0 ${isRTL ? 'md:pe-32' : 'md:ps-32'}`}>
                <div className="space-y-3 sm:space-y-4">
                  <h3 className="text-xl sm:text-2xl lg:text-3xl font-semibold">
                    {t('comingSoon.ourApp.heading') || 'Dr Easy... Your health at a single touch'}
                  </h3>
                  <p className="text-base sm:text-lg text-white/95 leading-relaxed">
                    {t('comingSoon.ourApp.subheading') || 'An app that simplifies your entire healthcare journey from booking appointments to tracking your condition.'}
                  </p>
                </div>

                {/* Features list */}
                <div className="space-y-2 sm:space-y-3 pt-2 sm:pt-4">
                  {features.map((item, index) => (
                    <div key={index} className="flex items-start gap-2 sm:gap-3">
                      <CheckOutlined className="text-white text-lg sm:text-xl mt-1 flex-shrink-0" />
                      <span className="text-base sm:text-lg text-white/95">{item}</span>
                    </div>
                  ))}
                </div>

                {/* Tagline */}
                <div className="pt-4 sm:pt-6">
                  <p className="text-lg sm:text-xl lg:text-2xl font-semibold">
                    {t('comingSoon.ourApp.tagline') || 'Dr Easy... Because your comfort comes first.'}
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}